/**
 *上传文件
 *props：
    *SNType：SN列表头
  *data:
    *uploadFileName:上传文件名
    *isUploaded:是否浏览完毕，控制进度条
    *uploadPercentage:进度条进度
    *uploadData:读取的文件数据
    *dialogVisible:是否显示上传组件
    *isEmpty:是否上传文件
  *methods
    *showProcess:设置进度条
    *upload:浏览文件
    *readExcel:读取文件数据
    *cancelUpload:取消选取文件
    *uploadToServer:将文件数据上传到服务器端
 */
<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="导入列表"
    name='uploadName'
    width="300px"
    custom-class="dialog" >
    <a>文件*</a><input readonly='readonly' v-model="uploadFileName" style="width:80%" :style="{'border-color':isEmpty?'red':'#ddd'}"/><a v-if="uploadPercentage==100" class="cancelUpload" @click="cancelUpload">X</a>
    <el-progress v-if="isUploaded" :percentage="uploadPercentage" ></el-progress>
    <p class="tip" style="margin-top: 14px;">*只支持xls和xlsx文件</p>
    <div class="dislogFooter">
    <div class="uploadBox" >
      浏览
      <input class="upload" type='file' @change="upload()"  ref="inputer"/>
    </div>
    <button @click="uploadToServer" class="leadIn">导入</button>
    </div>
    </el-dialog>
</template>

<script>
import XLSX from 'xlsx'
import format from '@/lib/format.js'
export default {
  name: 'Upload',
  mounted () {
  },
  props: {
    dataType: String
  },
  data () {
    return {
      uploadFileName: '',
      // 控制进度条显示
      isUploaded: false,
      uploadPercentage: 0,
      uploadData: [],
      isEmpty: false,
      dialogVisible: false,
      error: false,
    }
  },
  methods: {
    // 设置进度条
    showProcess (filename) {
      this.uploadPercentage = 0
      this.uploadFileName = ''
      this.isUploaded = true
      this.isEmpty = false
      for (let i = 0; i < 10; i++) {
        (function (i) {
          setTimeout(() => {
            this.uploadPercentage = (i + 1) * 10
            if (this.uploadPercentage === 100) {
              this.uploadFileName = filename
            }
          }, 15 * (i + 1))
        }).call(this, i)
      }
    },
    // ----------以下为导入Excel导入功能--------------
    upload (event) {
      this.uploadData = []
      this.readExcel(event)
    },
    // 给日期添加时区信息
    formatDate(numb, timeZone) {
      let resTime = numb
      if(typeof numb === 'number'){
        const old = numb - 1;
        const t = Math.round((old - Math.floor(old)) * 24 * 60 * 60);
        const time = new Date(1900, 0, old, 0, 0, t)
        resTime = time.getFullYear() + '/' + (time.getMonth()+1) + '/' + time.getDate()
      }
      if(typeof resTime !== 'string'){
        return false
      }
      if(timeZone&&timeZone.match(/^GMT/g)){
        let number = timeZone.split('GMT')[1]
        if(number&&!['-', '+'].includes(number[0])){
          timeZone = 'GMT' + '+' + number
        }
        resTime = resTime + ' ' + timeZone
      }
      return resTime
    },
    isvalidDate(date){
      if(!date.startDate || !date.endDate){
        return false
      }
      let flag = true
      try{
        flag = new Date(date.startDate).getFullYear()
      }catch(e){
        console.log("error: ", {date}, e)
      }

      if(!flag){
        return flag
      }
      if(date.endDate){
        flag = new Date(date.endDate).getFullYear()
      }

      return flag
    },
    getRange(value){
      const testReg = new RegExp('^\\[.+,.+]$', 'g')
      let min = 0, max = 0
      if(typeof value === 'string'&&value.match(testReg)){
        let [left, right] = value.replace(/\[|]/g, '').split(',')
        min = +left,
        max = +right
        if(!Number.isNaN(min)&&!Number.isNaN(max)&&min<=max){
          return [min, max]
        }
      }
      return false
    },
    // 读取数据
    readExcel (e) {
      let inputDOM = this.$refs.inputer
      const files = inputDOM.files[0]
      this.error = false
      if (!files) {
        // 如果没有文件
        return false
      } else if (!/\.(xls||xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error('上传格式不正确，请上传xls或xlsx格式')
        return false
      }
      const fileReader = new FileReader()
      fileReader.readAsBinaryString(files)
      fileReader.onload = (ev) => {
        const data = ev.target.result
        const workbook = XLSX.read(data, {
          type: 'binary'
        })
        const wsname = workbook.SheetNames[0] // 取第一张表
        const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]) // 生成json表格内容
        let errorAccount = []
        if (ws.length !== 0) {
          const relateName = {'开始日期':'startDate', '开闭环':'isOpen', '数据来源':'data_source', '组别':'group', '结束日期':'endDate', '账号':'account',
                              'Avg.SG':'avgSG', '<3.0':'below30Percent', 'TBR':'TBRPercent', 'TIR': 'TirPercent', 'TAR': 'tarPercent', '>13.9': 'beyond13Percent',
                               'Auto%': 'AutoPercent', 'Basal%': 'basalPercent', 'Bolus%': 'bolusPercent', '(TDD/Avg.TDD)%': 'TDDPercent',
                               '时区':'timeZone'
                              }
          for (let item in ws) {
            const tmp = {
              'startDate': '',
              'isOpen': '',
              'data_source': '',
              'group': '',
              'endDate': '',
              'account': '',
              'avgSG': '',
              'below30Percent': '',
              'TBRPercent': '',
              'TirPercent': '',
              'tarPercent': '',
              'beyond13Percent': '',
              'AutoPercent': '',
              'basalPercent': '',
              'bolusPercent': '',
              'TDDPercent': '',
              'timeZone': ''
            };
            for(let [key, value] of Object.entries(ws[item])){
              if(['开始日期', '结束日期'].includes(key)){
                value = this.formatDate(value, ws[item]['时区'])
                tmp[relateName[key]] = value
              }else if(['开闭环', '数据来源', '组别', '账号'].includes(key)){
                if(typeof value !== 'string'){
                  value = value + ''
                }
                tmp[relateName[key]] = value.trim()
              }else if(['Avg.SG', '<3.0', 'TBR', 'TIR', 'TAR', '>13.9', 'Auto%', 'Basal%', 'Bolus%', '(TDD/Avg.TDD)%'].includes(key)){
                let range = this.getRange(value)
                if(range){
                  tmp[relateName[key]] = range
                }else{
                  this.$message({
                    showClose:true,
                    message: `${ws[item]['组别']}组别下, ${ws[item]['账号']}账号的${key}取值范围有误！`,
                    type: 'error'
                  })
                  this.error = true
                }
              }
            }
            if(!tmp.endDate){
              let time = new Date()
              let gmt = tmp.startDate.split('GMT')[1]
              time = format.convertTimeZone(time, gmt).setHours(0,0,0,0)/1000
              tmp.endDate =  format.formatterDateHCL(time) + ' GMT' + gmt;
            }
            if(!this.isvalidDate(tmp) || new Date(tmp.startDate) > new Date(tmp.endDate)){
              errorAccount.push(tmp)
            }else{
              this.uploadData.push(tmp)
            }
            this.showProcess(inputDOM.files[0]['name'])
          }
        } else {
          this.$message.error('文件内容不规范！')
        }
        if(errorAccount.length!==0){
          const h = this.$createElement
          this.$msgbox({
            confirmButtonText: '确定',
            message: h('div', [
              h('span','提示: 下列账号时间设置有误，将不会显示结果!') , 
              h('div', {
                style: {
                  border:"1px solid black",
                  margin:"30px 0 0 10%",
                  width:"80%",
                  height:"100px",
                  overflow:"auto",
                }}, errorAccount.map(item=>{
                  if(this.dataType==='HCL'){
                    return h('p', `${item.group}组别下, ${item.account}账号的${item.data_source}数据`)
                  }else{
                    return h('p', `账户${item.account}的${item.data_source}数据`)
                  }
                }))
              ])
          })
        }
        // 清空input
        this.$refs.inputer.value = null
      }
    },
    // 取消选取文件
    cancelUpload () {
      this.isUploaded = false
      this.uploadPercentage = 0
      this.uploadFileName = ''
      this.uploadData = ''
      this.error = false
    },
    // 将文件数据上传到服务器端
    uploadToServer () {
      if (this.uploadData.length !== 0&&!this.error) {
        this.$emit('uploadToServer', this.uploadData)
        this.cancelUpload()
      } else {
        this.isEmpty = true
        this.$message.warning('请先上传文件')
      }
    }
  },
  watch: {
  }
}
</script>
<style scoped>
.btn {
  height: 30px;
  flex-flow: row;
  flex: 0 0 100px;
  color: #ffffff;
  font-size: 18px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
>>> .el-dialog__body {
  text-align: left;
  padding: 30px 20px 10px 20px;
}
/*a  upload */
.uploadBox {
    position: relative;
    cursor: pointer;
    border: 1px solid #ddd;
    border-radius: 50px;
    overflow: hidden;
    display: inline-block;
    *display: inline;
    line-height: 25px;
    text-align: center;
    height: 25px;
    width: 120px
}

.uploadBox  input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: pointer
}

.uploadBox:hover {
    color: #444;
    background: #eee;
    border-color: #ccc;
    text-decoration: none
}
.el-button {
  background-color: white;
  color: black;
}
.leadIn {
  height: 25px;
  width: 120px;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 50px;
  background-color: white;
}
>>> .dislogFooter {
  display: flex;
  margin-top: 75px;
  justify-content: space-evenly;
}
>>> .el-dialog {
  margin-top: 20vh!important;
  height: 230px;
  width: 350px!important;
  top: 0!important;
}
>>> .el-dialog__headerbtn{
  top: 3px;
}
>>> .el-dialog__headerbtn .el-dialog__close{
  color: white;
  margin: 5px;
}
>>> .el-dialog__title{
  line-height: 24px;
  font-size: 14px;
  color: white;
  font-family: PingFang SC;
}
>>> .el-dialog__title::before {
  content: '11';
  opacity: 0;
}
>>> .el-dialog__header {
  background-color: #0c544fff;
  text-align: left;
  padding: 0%;
}
>>> .el-dialog__body {
  text-align: left;
}
.tip::before {
    content: "1122";
    opacity: 0;
}
>>> .el-progress-bar {
  margin-right: 0px;
  padding: 0px 0px 0px 35px;
  width: 85%;
}
>>> .el-progress {
  top: 6px;
}
>>> .el-progress__text {
  margin-left: 5px;
}
.cancelUpload {
  color: red;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Upload.vue?7076b2f8